// Every newsletter issue, ready to send from Admin → Users → Email N selected.
//
// Publishing an issue means adding it here: the body as a .txt file in
// issues/ (the authoring format in lib/emailTemplate.ts), its images in
// public/newsletter/, and one entry below. issues.test.ts fails the build if an
// issue names an image that is not in public/newsletter/, so an issue cannot
// reach production pointing at a picture that will not load.

import issue01 from './issues/01-panels-have-more-to-give.txt?raw';
import issue02 from './issues/02-two-ways-to-run-a-load-calculation.txt?raw';

export interface NewsletterIssue {
  number: number;
  /** What the picker shows after the number: the issue's main topic. */
  feature: string;
  subject: string;
  body: string;
}

export const NEWSLETTER_ISSUES: NewsletterIssue[] = [
  {
    number: 1,
    feature: 'Panels have so much more to give',
    subject: 'TrueLoad – First Newsletter!',
    body: issue01,
  },
  {
    number: 2,
    feature: 'Two ways to run a load calculation',
    subject: 'Two ways to run a load calculation',
    body: issue02,
  },
];
